<template>
  <div class="flex flex-row justify-between items-center p-4">
    <!-- Logo -->
    <img src="/images/logo.svg" alt="Logo" />

    <!-- Toggle Button (visible on mobile screens) -->
    <button
      v-if="isMobile"
      class="block text-black hover:text-[#d44739] focus:outline-none md:hidden"
      @click="toggleMenu"
    >
      <!-- Hamburger Icon -->
      <img src="/images/icon-menu.svg" alt="Menu" />
    </button>

    <!-- Full-Screen Navigation Menu (Mobile) -->
    <div
      v-if="isMobile"
      :class="[
        'fixed top-0 left-0 w-full h-full bg-white z-20 transition-transform duration-300 md:hidden',
        menuOpen ? 'translate-x-0' : '-translate-x-full'
      ]"
    >
      <!-- Close Button -->
      <button
        class="absolute top-4 right-4 text-black hover:text-[#d44739] focus:outline-none"
        @click="toggleMenu"
      >
        <img src="/images/icon-menu-close.svg" alt="Close Menu" />
      </button>

      <!-- Navigation Items (Mobile) -->
      <ul class="flex flex-col items-start mt-20 ml-8 space-y-4">
        <li v-for="item in menuItems" :key="item">
          <a
            class="font-bold text-lg text-black hover:text-[#d44739] transition-all duration-200"
            href="#"
          >
            {{ item }}
          </a>
        </li>
      </ul>
    </div>

    <!-- Inline Navigation Menu (Desktop) -->
    <ul
      v-if="!isMobile"
      class="hidden md:flex flex-row space-x-6"
    >
      <li v-for="item in menuItems" :key="item">
        <a
          class="font-bold py-2 px-1 text-md text-black hover:cursor-pointer hover:text-[#d44739] transition-all duration-200"
          href="#"
        >
          {{ item }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line
  data() {
    return {
      menuOpen: false,
      isMobile: false,
      // eslint-disable-next-line
      menuItems: ["Home", "News", "Popular", "Trending", "Categories"],
    }
  },
  methods: {
    // eslint-disable-next-line
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    // eslint-disable-next-line
    checkIfMobile() {
      const wasMobile = this.isMobile
      this.isMobile = window.innerWidth <= 768
      if (wasMobile && !this.isMobile) {
        this.menuOpen = false
      }
    }
  },
  // eslint-disable-next-line
  mounted() {
    this.checkIfMobile()
    // eslint-disable-next-line
    window.addEventListener("resize", this.checkIfMobile)
  },
  // eslint-disable-next-line
  beforeUnmount() {
    // eslint-disable-next-line
    window.removeEventListener("resize", this.checkIfMobile)
  }
}
</script>
